import { useTranslations } from '@vocab/react';
import { Box, Text, IconTick, Hidden, IconLink } from 'braid-design-system';
import React from 'react';
import { sleep } from 'utils';

import type { Job } from 'src/types';
import { copyToClipboard } from 'src/utils/clipboard';

import { useConfig } from '../../../hooks/useConfig';

import translations from './.vocab';
import { createJobAdPath } from './links';

interface IconCopyActionProps {
  job: Job;
}

export const IconCopyAction: React.FC<
  React.PropsWithChildren<IconCopyActionProps>
> = ({ job }) => {
  const { t } = useTranslations(translations);
  const { urlResolver } = useConfig();

  const [copied, setCopied] = React.useState(false);

  const onClick = async () => {
    const path = createJobAdPath(job, 'direct-share-hirer-jobs-list');
    const jobAdUrl = urlResolver({ path, product: 'candidate' });

    await copyToClipboard(jobAdUrl);
    setCopied(true);
    await sleep(2000);
    setCopied(false);
  };

  return (
    <Box display="flex" alignItems="center" onClick={onClick} cursor="pointer">
      {copied ? (
        <IconTick
          tone="positive"
          titleId={`${job.jobId}-linked-in`}
          title={t('URL copied')}
        />
      ) : (
        <IconLink
          tone="neutral"
          titleId={`${job.jobId}-copy-url`}
          title={t('Copy URL')}
        />
      )}
      <Hidden below="tablet">
        {copied && (
          <Box paddingLeft="small">
            <Text tone="positive" size="large">
              {t('Copied!')}
            </Text>
          </Box>
        )}
      </Hidden>
    </Box>
  );
};
